// @flow

import ReactGA from 'react-ga';

import React, { Component } from 'react';
import InputRange from 'react-input-range';

import 'react-input-range/lib/css/index.css';
import './Slider.css';

const toHundreth = raw => {
  return Math.round(raw * 100) / 100;
};

class Slider extends Component {
  state: Object;
  value: number;
  onTick: Function;

  constructor(props: Object) {
    super(props);
    this.onTick = this.onTick.bind(this);

    this.state = {
      animationEnabled: false,
      animationDirection: 1,
    };
  }

  componentDidMount() {
    setInterval(this.onTick, 250);
  }

  onTick() {
    const { enabled, filterName, limits, onFilterChange, value, step } = this.props;

    const { animationDirection, animationEnabled } = this.state;

    if (!animationEnabled || !enabled) {
      return;
    }

    const newMin = toHundreth(value.min + animationDirection * step);
    const newMax = toHundreth(value.max + animationDirection * step);

    if (newMax > limits.max || newMin < limits.min) {
      this.setState({ animationDirection: -animationDirection });
    } else {
      onFilterChange({
        filterName,
        enabled,
        value: { min: newMin, max: newMax },
      });
    }
  }

  render() {
    const {
      enabled,
      filterName,
      formatLabel,
      label,
      onFilterChange,
      limits,
      value,
      step,
    } = this.props;

    const { animationEnabled } = this.state;

    const onValueChange = value => {
      onFilterChange({ filterName, enabled, value });
    };

    const onEnabledChange = event => {
      onFilterChange({ filterName, enabled: !enabled, value });
    };

    const onStep = direction => {
      const newValue = {
        min: toHundreth(value.min + direction * step),
        max: toHundreth(value.max + direction * step),
      };

      if (newValue.min >= limits.min && newValue.max <= limits.max) {
        onFilterChange({ filterName, enabled, value: newValue });
      }

      ReactGA.event({
        category: 'Filter',
        action: 'Step',
        label: filterName,
      });
    };

    const onAnimationChange = event => {
      const newValue = !animationEnabled;

      this.setState({ animationEnabled: newValue });

      const action = newValue ? 'Play' : 'Pause';
      ReactGA.event({
        category: 'Filter',
        action,
        label: filterName,
      });
    };

    return (
      <div className="Slider filter">
        <div className="top">
          <label>
            <input type="checkbox" onChange={onEnabledChange} checked={enabled} />
            {label}
          </label>
        </div>
        {enabled && (
          <div className="control">
            <i onClick={() => onStep(-1)} className="material-icons">
              skip_previous
            </i>

            <InputRange
              formatLabel={formatLabel}
              maxValue={limits.max}
              minValue={limits.min}
              onChange={onValueChange}
              step={step}
              type="range"
              value={value}
            />
            <i onClick={() => onStep(1)} className="material-icons">
              skip_next
            </i>
            {animationEnabled && (
              <i onClick={onAnimationChange} className="material-icons">
                pause
              </i>
            )}
            {!animationEnabled && (
              <i onClick={onAnimationChange} className="material-icons">
                play_arrow
              </i>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js